import { connect } from 'react-redux';
import SingleMasavExport from './SingleMasavExport';
import { Actions } from '../actions';
import {
  selectMasavExportsLoading,
  selectCurrentMasavExport
} from '../../modules/masavExports/selectors';

const mapStateToProps = (state) => ({
  loading: selectMasavExportsLoading(state),
  masavExport: selectCurrentMasavExport(state)
});

const mapDispatchToProps = (dispatch) => ({
  onMount: (id) => dispatch(Actions.SINGLE_MASAV_EXPORT_PAGE_MOUNTED(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleMasavExport);

